module.exports = __webpack_public_path__ + "img/help-center@2x.a0f396d8.png";